export const dashboardRoutes = {
	dashboard: '/'
} as const
